import React, { useState, useContext, useEffect, useRef } from "react";
import { globalFileIcon } from "../../../axiosInstance";
import Chat from "./chat";
import { GlobalContext } from "./GlobalContext";


export default function CustomerService({ setOpenMenu }) {
  const [openChat, _setOpenChat] = useState(false);
  const { email, subject } = useContext(GlobalContext);
  const menuRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpenMenu(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setOpenMenu]);

  return (
    <div ref={menuRef}>
      <p className="header">
        קליק
        <br /> ונשמח לעזור:
      </p>
      <a
        href={`mailto:${email}?subject=${subject}`}
        onClick={() => setOpenMenu(false)}
        target="_blank"
        className="option"
        rel="noreferrer"
      >
        <img
          loading="lazy"
          src={globalFileIcon + "emailService.svg"}
          alt="emailService"
        />
        בדוא"ל
      </a>
      <span>s@hamazon.co.il</span>
      <a
        href="tel:+97225327277"
        target="_blank"
        className="option"
        onClick={() => setOpenMenu(false)}
        rel="noreferrer"
      >
        <img
          loading="lazy"
          src={globalFileIcon + "phoneService.svg"}
          alt="phoneService"
        />
        בטלפון:{" "}
      </a>
      <span className="tel-num">02-5327-277</span>
      <div
        className="close-menu"
        onClick={() => setOpenMenu(false)}
        style={{
          backgroundImage: `url(${globalFileIcon + "closePrivateArea.svg"})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "100%",
          backgroundColor: "transparent",
        }}
      ></div>
      {openChat ? <Chat setOpenMenu={setOpenMenu} /> : null}
    </div>
  );
}
